import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import GeneralLoader from "../components/common/GeneralLoader";
import { PlayIcon } from "../components/icons/Play";
import { API_BASE_URL } from "../config";
import axiosInstance from "../config/axios";
import useSongStore from "../store/song.store";
import { e2p } from "../utils";
import { handleApiError } from "../utils/handleApiError";

const titles: any = {
  0: "قطعه اول",
  1: "قطعه دوم",
  2: "قطعه سوم",
  3: "قطعه چهارم",
  4: "قطعه پنجم",
  5: "قطعه ششم",
};

const SongPartsScreen = () => {
  const navigate = useNavigate();

  const songDetails = useSongStore((state) => state.songDetails);
  const setToneCode = useSongStore((state) => state.setToneCode);

  const [isLoading, setIsLoading] = useState(false);

  // state برای نگه‌داری id ترک در حال پخش
  const [currentTrack, setCurrentTrack] = useState<number | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handlePlay = (track: any, index: number) => {
    if (!track?.music_url) return;

    // اگه همون آهنگ در حال پخش باشه → پاز کن
    if (currentTrack === track.id && !audioRef.current?.paused) {
      audioRef.current?.pause();
      setCurrentTrack(null);
      return;
    }

    // اگه آهنگ جدید باشه → سورس جدید بده و پلی کن
    if (audioRef.current) {
      audioRef.current.src = track.music_url;
      audioRef.current.play().catch((err) => console.warn("Play failed:", err));
      setCurrentTrack(track.id);
    }
  };

  const activateHandler = async (track: any) => {
    try {
      setIsLoading(true);

      await axiosInstance.post(API_BASE_URL + "v1/activation/", {
        tone_code: track?.code,
      });

      setToneCode(track?.code);

      toast.success("کد اعتبارسنجی با موفقیت ارسال شد.");

      navigate("/otp-activation");
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return songDetails ? (
    <div className="w-full h-full text-white flex flex-col items-center px-4 py-6 overflow-y-auto">
      {isLoading ? <GeneralLoader hasBackground={true} /> : null}

      <div className="w-full max-w-md rounded-xl overflow-hidden mb-4 mt-20">
        <img
          className="w-full h-auto"
          alt={songDetails?.track?.name}
          src={songDetails?.track?.cover}
        />
      </div>

      <h1 className="text-xl md:text-2xl font-bold text-center">
        {songDetails?.track?.name}
      </h1>
      <p className="text-base font-semibold text-white/80 mb-6">
        {songDetails?.track?.singer?.name}
      </p>

      <div className="w-full max-w-md space-y-4">
        {songDetails?.track?.rbt_code?.map((track: any, index: any) => (
          <div
            key={track.id}
            className="bg-white text-black rounded-xl px-4 py-3 flex items-center justify-between shadow-md"
          >
            <div
              onClick={() => handlePlay(track, index)}
              className="flex items-center gap-2"
            >
              <PlayIcon className="size-10" />
              <span className="font-semibold text-base">{titles?.[index]}</span>
            </div>

            <button
              onClick={() => {
                activateHandler(track);
              }}
              className="bg-[#f54f02] hover:bg-orange-600 text-white font-bold px-4 py-2 rounded-lg text-sm"
            >
              فعال‌سازی
            </button>

            <div className="flex flex-col font-semibold text-right text-gray-700">
              <span className="text-lg">
                {track?.duration ? e2p(`${track?.duration}`) : track?.duration} روز
              </span>
              <span className="text-xl">
                {track?.price / 10 ? e2p(`${track?.price / 10}`) : track?.price / 10}{" "}
                تومان
              </span>
            </div>
          </div>
        ))}
      </div>

      <audio ref={audioRef} hidden />
    </div>
  ) : null;
};

export default SongPartsScreen;
